// extracted by mini-css-extract-plugin
module.exports = {"header":"header--3uqyQ","headertitle":"headertitle--ZrAGb","headerimage":"headerimage--3z0pF","headerinfo":"headerinfo--36K5Q","headermenu":"headermenu--oLlkr"};